"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _shared = _interopRequireDefault(require("../_shared"));

var _default = {
  cssVars: "\n    :root {\n      ".concat(_shared["default"], "\n      --sans-serif:\n        'Open Sans',\n        -apple-system, BlinkMacSystemFont,\n        'avenir next', avenir,\n        helvetica, 'helvetica neue',\n        ubuntu,\n        noto,\n        'segoe ui',\n        arial,\n        sans-serif;\n      --serif: georgia, serif;\n      --code: consolas, monaco, monospace;\n      --black: #000000;\n      --near-black: #1c2833;\n      --navy: #001b44;\n      --dark-blue: #031f73;\n      --pacific-blue: #0093d6;\n      --blue: #3e7697;\n      --light-blue: #3455db;\n      --lightest-blue: #d4e4f5;\n      --alice-blue: #eafaff;\n      --outline-blue: #286fad;\n      --washed-blue: #e9f1fa;\n      --dark-red: #ed1c24;\n      --red: #ed1c24;\n      --light-red: #fcdada;\n      --orange: #f96302;\n      --dark-orange: #cb4814;\n      --light-orange: #fed4B9;\n      --green: #00ae4d;\n      --light-green: #ecfff5;\n      --gold: #ffb700;\n      --yellow: #ffcc20;\n      --light-yellow: #fbf1a9;\n      --dark-gray: #707c80;\n      --gray: #cccccc;\n      --mid-gray: #eeeeee;\n      --light-gray: #f8f8f8;\n      --near-white: #f4f4f4;\n      --white: #ffffff;\n    }\n  "),
  name: 'Pallet',
  backgroundColor: 'bg-white',
  accordion: {
    accordion: '',
    animateContentDisplay: true,
    item: {
      content: 'pa3 bl br bb b--gray',
      title: {
        base: {
          heading: {
            wrapper: 'f3 ba b--gray',
            text: 'bb b--orange bw1 pb1'
          },
          normal: {
            wrapper: 'f4 ba b--gray',
            text: ''
          }
        },
        collapsed: 'bg-white',
        expanded: 'bg-mid-gray',
        collapsedAlternate: 'bg-white',
        expandedAlternate: 'bg-mid-gray',
        padding: 'pa3',
        lastItemClosedStyle: '',
        toggle: {
          color: 'orange',
          icon: 'MdExpandMore',
          position: 'right',
          css: {
            collapsed: "\n              transform: rotate(0);\n            ",
            expanded: "\n              transform: rotate(180deg);\n            "
          }
        }
      }
    }
  },
  alert: {
    base: 'ba items-center',
    icons: {
      error: {
        color: 'near-black',
        vector: 'MdNotInterested'
      },
      success: {
        color: 'near-black',
        vector: 'CheckOutline'
      },
      warning: {
        color: 'near-black',
        vector: 'MdErrorOutline'
      }
    },
    spacing: 'pa1 pa2-ns mb3',
    types: {
      error: 'near-black b--red bg-light-red',
      primary: 'near-black b--pacific-blue bg-alice-blue',
      secondary: 'near-black b--gray bg-light-gray',
      success: 'near-black b--green bg-light-green',
      warning: 'near-black b--yellow bg-light-yellow'
    },
    typography: 'sans-serif f6'
  },
  avatar: {
    color: 'blue',
    size: '200px'
  },
  badges: [],
  banner: {
    background: 'var(--white)',
    border: '1px solid var(--mid-gray)',
    heading: {
      fontWeight: '700',
      fontSize: '3rem',
      lineHeight: '4.25rem',
      paddingBottom: '10px'
    },
    subHeading: {
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '22px',
      paddingBottom: '25px'
    },
    anchor: {
      padding: '0 5px',
      textDecoration: 'underline',
      textDecorationLine: 'underline',
      color: 'var(--blue)'
    },
    imageBox: {
      borderColor: 'var(--mid-gray)',
      backgroundColor: 'var(--light-gray)'
    },
    imageBoxDragAccept: {
      borderColor: 'var(--green)'
    },
    imageBoxDragReject: {
      borderColor: 'var(--red)'
    },
    imageBoxFocused: {
      borderColor: 'var(--blue)'
    }
  },
  breadcrumbs: {
    delimiter: '/',
    fontSize: 'f6',
    linkColor: 'orange',
    maxWidth: '1440px',
    isVisible: true
  },
  brightcoveplayer: 'lMczQWpmw',
  button: {
    base: 'br1 bw1',
    hoverBackgroundColor: 'rgba(255, 255, 255, 0.15)',
    scaleOnHover: false,
    sizes: {
      normal: 'ph4 pv3 f5',
      small: 'ph3 pv2 f6'
    },
    disabled: {
      appearance: 'b--gray bg-gray',
      text: 'white',
      outline: {
        appearance: 'b--gray bg-transparent',
        text: 'gray'
      }
    },
    primary: {
      appearance: 'bg-orange b--orange',
      text: 'white',
      outline: {
        appearance: 'bg-transparent b--orange',
        text: 'orange'
      },
      overrides: "\n        &:after {\n          content: '';\n          position: absolute;\n          border: none;\n          left: -4px;\n          right: -4px;\n          bottom: -4px;\n        }\n      "
    },
    secondary: {
      appearance: 'bg-transparent b--orange',
      text: 'orange',
      outline: {
        appearance: 'bg-transparent b--orange',
        text: 'orange'
      }
    },
    tertiary: {
      appearance: 'bg-transparent b--transparent',
      text: 'blue underline',
      outline: {
        appearance: 'bg-transparent b--transparent',
        text: 'blue'
      }
    },
    alert: {
      appearance: 'bg-red b--red',
      text: 'white underline',
      outline: {
        appearance: 'bg-transparent b--red',
        text: 'red'
      }
    }
  },
  checkbox: {
    checkboxBorderColor: 'gray',
    checkboxBorderRadius: '0px',
    checkboxBorderWidth: '2px',
    checkboxColorChecked: 'green',
    checkboxColorDisabled: 'mid-gray',
    checkboxColorHover: 'transparent',
    checkboxSize: '15px',
    checkmarkColor: 'white',
    checkmarkPosition: 'left: 5px; top: 0px; width: 4px; height: 9px;',
    textColorDisabled: 'gray',
    textLeftOffset: '1.5rem',
    textTopOffset: '1px'
  },
  configurator: {
    enablePayPal: false,
    showExternalPromoMessage: false,
    draftBanner: {
      logoName: 'thd-logo'
    },
    global: "\n      .configurator-container hr { display: none };\n    ",
    choice: {
      border: '',
      maxWidth: 'mw4'
    },
    choiceContainer: {
      borderRadius: '4px 0px 4px 4px',
      boxShadow: '0 4px 9px 0 #ccc, 0 3px 10px 0 #ccc',
      borderWidth: '1px',
      display: 'none',
      justifyContent: 'space-between',
      padding: '0px',
      paddingLeft: '0px',
      paddingBottom: '0px',
      zoomImage: {
        tachyons: "left-0",
        css: ""
      }
    },
    option: {
      base: 'relative-ns bn ba-ns flex-shrink-0',
      dictionaryTermBackgroundColor: '  bg-near-black',
      dictionaryTermColor: 'dark-gray',
      dictionaryTermIconColor: 'dark-gray',
      image: '',
      selectedIcon: 'orange',
      selectedText: 'orange',
      selectedLabel: '',
      sizeGroup: 'flex-wrap flex-nowrap-ns',
      showDivider: false,
      title: {
        base: 'f3 fw5 pt3 pr3 mb3 ttc bb b--moon-gray',
        border: 'dib bb bw1 b--orange pb2'
      }
    },
    price: {
      addsPrice: 'black',
      text: 'black',
      width: 'w-55',
      padding: 'pr2',
      alignment: 'right',
      showShipping: true
    },
    productInfo: {
      price: {
        dimensions: false
      }
    },
    ctaLabelsAlignments: 'justify-end',
    promo: 'dark-red',
    shipping: 'dn',
    summary: {
      background: 'bg-light-gray',
      border: 'none',
      choiceValue: 'black',
      floatingBar: {
        background: 'bg-navy',
        priceColor: 'white'
      },
      stickyTop: '1rem'
    }
  },
  contentBox: {
    appearance: 'bg-white br1 ba b--gray pa2 shadow-1',
    content: 'f6',
    expandArrowColor: 'orange',
    title: 'f4 f3-ns fw4',
    overrides: "\n      transition: all 0.1s cubic-bezier(0.5, 0, 0.1, 1) 0s;\n      &:hover {\n        box-shadow: 0 6px 12px 0 rgb(0 0 0 / 20%);\n      }\n    "
  },
  pip: {
    preview: {
      container: {
        maxWidth: 'max-width: 350px;'
      },
      samples: {
        tachyons: 'dn db-ns'
      },
      visualizer: {
        floatingTopPosition: '9rem'
      },
      selectedSwatch: '',
      selectedSwatchTy: 'bb b--gray ',
      selectedSwatchInfo: 'pl3',
      styledInfo: 'ph3 ph4-l pb4-l',
      priceAndPromo: ''
    },
    productSpecifications: {
      adobeDownloadDisabled: []
    },
    productSummary: {
      howToGetIt: {
        variant: 'dynamic',
        "static": {
          color: 'var(--near-black)'
        }
      },
      howToGetItBorder: {
        border: 'none'
      },
      dimensionDropdowns: {
        showLabelValues: false
      },
      productInstallationCtaViewDisable: false,
      ctaHide: {
        display: 'none'
      }
    },
    productOptions: {
      showSampleOrderAlert: {
        display: 'block'
      }
    },
    productOverview: {
      exchangeDays: 15,
      mustReturnProduct: false,
      exclusiveGuarantee: true
    },
    productGallery: {
      internetNumLabel: 'Internet #'
    }
  },
  dropdown: {
    arrowColor: 'orange',
    arrowVector: 'caret',
    borderBottomWidth: '2px',
    borderColor: 'b--gray',
    borderErrorColor: 'b--red',
    borderWidth: '1px',
    borderRadius: 'br0',
    disabledLabel: 'near-black',
    focusBorderColor: 'orange',
    label: 'sans-serif'
  },
  formComponents: {
    fontSize: {
      input: '16px',
      label: '16px'
    },
    inputDropdownHeight: {
      normal: '40px',
      small: '36px'
    }
  },
  globalStyles: '',
  heading: {
    primary: {
      container: 'bb b--black-10',
      text: 'bb bw2 b--orange'
    },
    secondary: {
      container: 'bb bw2 b--orange',
      text: ''
    },
    tertiary: {
      container: '',
      text: ''
    },
    font: {
      tachyons: {
        h1: 'f1 fw3 black',
        h2: 'fw6 black',
        h3: 'f3 fw4 black',
        h4: 'fw6 black',
        h5: 'f5 fw6 black',
        h6: 'f6 fw6 black',
        h7: 'f6 fw4 dark-gray'
      },
      manual: {
        h2: 'font-size: 1.75rem;',
        h4: 'font-size: 1.125rem;'
      }
    }
  },
  internalUser: {
    showEmptyCartLink: false
  },
  leadGeneration: {
    getStarted: {
      accountIcon: {
        color: 'var(--white)',
        size: '3em'
      },
      checkIcon: {
        color: 'var(--green)',
        size: '2em'
      },
      clockIcon: {
        color: 'var(--white)',
        size: '2.25em'
      },
      phoneIcon: {
        color: 'var(--orange)',
        size: '1.75em'
      }
    },
    highlighted: 'fw7 tc w-100 orange',
    howItWorks: {
      list: {
        style: "\n          content: counter(index, decimal);\n          counter-increment: index;\n          background-color: var(--orange);\n          color: var(--white);\n          display: inline-block;\n          position: absolute;\n          height: 1.75em;\n          width: 1.75em;\n          text-align: center;\n          vertical-align: middle;\n          line-height: 1.75em;\n          border-radius: 5em;",
        vertical: "left: 0;",
        horizontal: "top: -2.5em;"
      }
    },
    verifyAddress: {
      style: 'w-100 bg-light-blue',
      locationIcon: {
        color: 'blue',
        size: '1.25em'
      }
    }
  },
  link: {
    types: {
      anchor: {
        "default": 'underline blue',
        hover: ''
      },
      'high-visibility': {
        "default": 'b black',
        hover: 'underline',
        icon: {
          code: 'MdChevronRight',
          color: 'orange',
          position: 'after'
        }
      },
      standard: {
        "default": 'no-underline black',
        hover: 'underline'
      },
      remove: {
        "default": 'black no-underline b',
        hover: 'underline',
        icon: {
          code: 'MdClose',
          color: 'red',
          position: 'before'
        }
      }
    }
  },
  modal: {
    settings: {
      footer: true
    },
    body: 'ph0',
    borderRadius: 'br0',
    boxShadowCss: '0px 0px 40px rgba(0, 0, 0, 0.5)',
    closeButton: 'black',
    content: {
      appearance: '',
      withTitle: 'ph0'
    },
    footer: {
      appearance: 'bt b--gray pa2 flex justify-end',
      content: ''
    },
    header: {
      appearance: 'pa3',
      withTitle: ''
    },
    overlayColorRgba: 'rgba(0,0,0,.8)',
    overrides: "\n      & [class*=\"StyledModalContent\"] .body {\n        padding-left: 1.5rem;\n        padding-right: 1.5rem;\n      }\n    ",
    title: 'fw5 f3 pa2'
  },
  newsletterSignUp: undefined,
  price: {
    color: 'near-black',
    currency: '$',
    displayOrder: {
      prefix: 2,
      price: 1,
      promo: 3,
      suffix: 6,
      promoDesc: 7,
      promoSavings: 4,
      stackable: 5
    },
    prefix: '',
    savingsColor: 'green',
    strikethroughColor: 'gray',
    suffix: '',
    superscriptCents: false,
    superscriptCurrency: false,
    showCentsDelimiter: false,
    priceFontSizeSmall: 'f2',
    priceFontSizeExSmall: 'f4'
  },
  quantity: {
    backgroundColor: 'bg-white',
    borderColor: 'b--dark-gray',
    borderRadius: 'br1',
    borderWeight: '',
    componentType: 'quantity'
  },
  radioButton: {
    radioButtonBackgroundColor: 'green',
    radioButtonBackgroundColorChecked: 'white',
    radioButtonBorderColor: 'gray',
    radioButtonBorderColorChecked: 'green',
    radioButtonBorderWidth: '2px',
    radioButtonColorChecked: 'green',
    radioButtonColorDisabled: 'mid-gray',
    radioButtonColorHover: 'transparent',
    radioButtonSize: '16px',
    radioButtonColor: 'white',
    textColorDisabled: 'gray',
    textLeftOffset: '2rem',
    textTopOffset: '1px'
  },
  rightRailFlyout: {
    enabled: false,
    squareWidth: 40
  },
  orangePay: {
    cssStylesOverrides: "\n      .flex-container {\n        padding: 0;\n      }\n    ",
    borderWidth: '1px',
    formPaddingBottom: '2rem',
    formPaddingTop: '2rem',
    formMarginBottom: '0px',
    titleVisibility: 'visible'
  },
  selectionBox: {
    choiceSelectionBox: true,
    imageSelectionBox: false,
    borderColor: 'gray',
    borderColorSelected: 'orange',
    borderRadius: 'br0',
    checked: {
      base: 'w3 h3 white flex items-center justify-center absolute z-1',
      container: 'w3 overflow-hidden',
      overrides: "\n        transform: rotate(45deg);\n        font-size: 0.8rem;\n        top: -2.5rem;\n        right: -2.5rem;\n        align-items: flex-end;\n        justify-content: center;\n        & svg {\n          padding-bottom: 0.2rem;\n          transform: rotate(-45deg);\n          & path {\n            stroke: #fff;\n            stroke-width: 3px;\n          }\n        }\n      "
    }
  },
  spinner: {
    color: 'orange'
  },
  tag: {
    borderRadius: '.25rem',
    primary: {
      appearance: 'b--gold bg-gold',
      text: 'near-black'
    },
    secondary: {
      appearance: 'b--light-gray bg-light-gray',
      text: 'near-black'
    }
  },
  textInput: {
    borderColor: 'b--black',
    borderColorFocus: 'b--gray',
    errorColor: 'dark-red',
    borderRadius: 'br1',
    borderWidth: '1px',
    disabledBackground: 'mid-gray',
    disabledLabel: 'dark-gray sans-serif',
    label: 'near-black sans-serif',
    secondarylabel: 'dark-gray sans-serif i',
    showErrorIcon: true
  },
  table: {
    headerCell: 'fw5',
    size: {
      normal: {
        cellSize: 'pa2',
        headerCellSize: 'pa2'
      },
      large: {
        cellSize: 'pa3',
        headerCellSize: 'pa3'
      }
    },
    type: {
      standard: {
        cell: {
          tachyons: 'bt b--mid-gray',
          css: ''
        },
        row: {},
        header: 'bg-light-gray',
        rowBgColor: 'bg-white'
      },
      stripes: {
        cell: {
          tachyons: '',
          css: ''
        },
        row: {},
        rowBgColor: 'bg-light-gray'
      }
    },
    typography: 'sans-serif f5'
  },
  textInputButton: {
    borderColor: 'b--mid-gray',
    borderRadius: undefined,
    borderWidth: '2px',
    fontSize: 'f6'
  },
  toggleSwitch: {
    checked: 'var(--green)',
    unchecked: 'var(--gray)'
  },
  visualizer: {
    _settings: {
      actionButtons: 'secondary'
    },
    design: {
      fixedTopPosition: {
        large: '1rem',
        medium: '9rem',
        small: '9rem'
      },
      zoomOut: null
    }
  }
};
exports["default"] = _default;